import type { BrandConfig } from '../types'
import placeholderImage from './assets/placeholder.svg'
import logoImage from './assets/logo.svg'
import testimonial1 from './assets/testimonial-1.svg'
import testimonial2 from './assets/testimonial-2.svg'
import testimonial3 from './assets/testimonial-3.svg'

const config: BrandConfig = {
  appName: 'LearnCore',
  brandName: 'LearnCore',
  description: 'Sistema de agendamento para tutores',
  logo: {
    src: logoImage,
    alt: 'Logótipo da marca',
  },
  heroImage: {
    src: placeholderImage,
    alt: 'Professor particular ensinando aluno',
  },
  serviceImage: {
    src: placeholderImage,
    alt: 'Aula particular em progresso',
  },
  testimonials: [
    {
      name: 'Professor Ramos',
      role: 'Tutor de Matemática',
      text: 'O LearnCore ajuda-me a gerir as minhas aulas e a comunicar com os pais dos alunos. Muito prático.',
      image: testimonial1,
    },
    {
      name: 'Sofia B.',
      role: 'Aluna do 10º ano',
      text: 'Marcar as minhas explicações online é muito mais fácil do que andar a trocar mensagens.',
      image: testimonial2,
    },
    {
      name: 'Centro de Estudos Saber',
      role: 'Coordenação',
      text: 'Conseguimos organizar os horários de todos os nossos tutores e alunos numa única plataforma. Fantástico!',
      image: testimonial3,
    },
  ],
  terminology: {
    professional: 'explicador',
    professionals: 'explicadores',
    business: 'centro',
    businesses: 'centros',
    service: 'explicação',
    services: 'explicações',
    client: 'aluno',
    clients: 'alunos',
    appointment: 'aula',
    appointments: 'aulas',
  },
  homepage: {
    hero: {
      badge: 'Educação Personalizada',
      title: 'Ensine com excelência usando LearnCore',
      description: 'Organize suas explicações e potencialize o aprendizado dos seus alunos com o LearnCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Agendar Demonstração',
      features: ['Setup em 5 minutos', 'App mobile incluído'],
    },
    statistics: [
      { value: '420+', label: 'Explicadores' },
      { value: '38k+', label: 'Explicações Realizadas' },
      { value: '96%', label: 'Satisfação' },
    ],
    painPoints: [
      {
        title: 'Horários Incompatíveis',
        description: 'Coordenar horários entre pais, alunos e disponibilidade do explicador é complexo.',
        icon: 'Calendar',
        quote: {
          text: 'Antes do LearnCore perdia 1 hora diária só a coordenar horários por telefone e WhatsApp',
          author: 'Professora Helena Sousa',
          business: 'Explicações Sousa',
        },
      },
      {
        title: 'Material Inadequado',
        description: 'Sem saber antecipadamente a matéria, é difícil preparar exercícios e material específico.',
        icon: 'BookOpen',
        stats: [
          { label: 'Aulas mal preparadas:', value: '30%' },
          { label: 'Tempo perdido a procurar material:', value: '5h/semana' },
        ],
      },
      {
        title: 'Acompanhamento de Progresso',
        description: 'Sem registos digitais, é difícil acompanhar evolução do aluno e comunicar com pais.',
        icon: 'TrendingUp',
        quote: {
          text: 'Com o registo de progresso os pais veem a evolução e o aluno fica mais motivado',
          author: 'Professor João Mendes',
          business: 'Centro Saber+',
        },
      },
    ],
    solution: {
      badge: 'A Solução',
      title: 'LearnCore: O seu centro de aprendizagem',
      description: 'Tecnologia educativa para explicadores que transformam vidas através do ensino.',
      features: [
        {
          title: 'Agendamento Inteligente',
          description: 'Pais e alunos veem disponibilidade real e marcam considerando preferências de matéria.',
        },
        {
          title: 'Preparação de Aulas',
          description: 'Saiba antecipadamente tópicos e dificuldades para preparar material personalizado.',
        },
        {
          title: 'Relatórios de Progresso',
          description: 'Acompanhe evolução de cada aluno e partilhe relatórios com pais automaticamente.',
        },
      ],
    },
    testimonials: {
      title: 'O que os explicadores dizem',
      description: 'Explicadores que potencializaram o ensino com o LearnCore.',
    },
    finalCta: {
      title: 'Pronto para revolucionar o ensino?',
      description: 'Junte-se aos explicadores que já transformaram a educação com o LearnCore.',
      ctaPrimary: 'Começar Gratuitamente',
      ctaSecondary: 'Ver Demonstração',
    },
    contact: {
      title: 'Fale Conosco',
    },
  },
  auth: {
    register: {
      title: 'Criar uma conta',
      description: 'Preencha os dados abaixo para se registrar',
      inviteDescription: 'Crie sua conta para aceitar o convite de explicador',
      subscriptionDescription: 'Crie sua conta para finalizar sua assinatura',
      inviteCodeLabel: 'Você está usando um código de convite',
      subscriptionLabel: 'Você selecionou um plano de assinatura',
    },
    login: {
      title: 'Entrar na conta',
      description: 'Digite suas credenciais para acessar',
    },
  },
}

export default config